import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class ImageService {

  ImageLoc(relativeUrl): string {
    if (window["spaSourceUrl"]) {
      if (relativeUrl.charAt(0) === '.') {
        relativeUrl = relativeUrl.substring(1);
      }      
      return window["spaSourceUrl"] + relativeUrl;
    }
    
    if (environment.env === 'dev') {
      return relativeUrl.replace('/files', '');
    }

    return relativeUrl;
  }

  HelpImageLoc(text: string): string {
    if (window["spaSourceUrl"]) {
      let base = window["spaSourceUrl"].toString();
      if (base.substring(base.length - 1, 1) !== "/") {
        base = base + "/";
      }
      text = text.replace(/\.\/assets/g, base + "files\/assets");
    }

    return text;
  }
}
